
import Vue from 'vue';
import FileUploadIcon from './assets/file-upload.vue.svg';
import PublicPortfolioModal from '~/components/partials/public-portfolio/PublicPortfolioModal.vue';
import BravadoButtonV3 from '~/components/common/BravadoButtonV3/BravadoButtonV3.vue';
import type { IFileUploader } from '~/components/common/FileUpload.vue';
import FileUpload from '~/components/common/FileUpload.vue';
import uploader from '~/components/utils/uploader';
import type { FormState } from '~/types/common';
import type { ApproveTestimonialMixinType } from '~/components/partials/public-portfolio/PublicPortfolioTestimonials/mixins/approveTestimonialMixin';
import approveTestimonialMixin from '~/components/partials/public-portfolio/PublicPortfolioTestimonials/mixins/approveTestimonialMixin';
import { getTestimonialApprovalRoute } from '~/components/partials/public-portfolio/PublicPortfolioTestimonials/utils';

interface IData {
  file: File | null;
  uploadState: FormState;
}

export default (Vue as ApproveTestimonialMixinType).extend({
  name: 'PublicPortfolioTestimonialScreenshotModal',
  components: { FileUpload, PublicPortfolioModal, BravadoButtonV3, FileUploadIcon },
  mixins: [approveTestimonialMixin],
  data(): IData {
    return {
      file: null,
      uploadState: 'idle',
    };
  },
  computed: {
    isButtonDisabled(): boolean {
      return !this.file || this.uploadState === 'submitting';
    },
  },
  methods: {
    async handleBack(testimonialId: string): Promise<void> {
      const route = getTestimonialApprovalRoute(this.$route.params.slug, testimonialId);
      await this.$router.push(route);
    },
    openFileDialog() {
      (this.$refs.uploader as unknown as IFileUploader).open();
    },
    onFileChange({ files }: { name: string; files: File[] }) {
      const file = files[0];

      if (file) {
        if (parseFloat((file.size / 1024 ** 2).toFixed(2)) > 5) {
          this.$notice.error('File size can not exceed 5 Mb');
        } else {
          this.file = files[0];
        }
      }
    },
    async uploadFile(): Promise<void> {
      if (this.file) {
        this.uploadState = 'submitting';
        this.logEvent('manual');
        try {
          const { signed_id } = await uploader.upload({ file: this.file, token: this.$auth.user!.token! });

          await this.approveTestimonial({ confirmationScreenshotSignedId: signed_id, author: { linkedinUrl: null } });
        } catch {
          this.$notice.error('Unable to upload screenshot');
        } finally {
          this.uploadState = 'idle';
        }
      }
    },
  },
});
